import { render } from "./lookbook-product-grid-modal.vue?vue&type=template&id=45498b54"
import script from "./lookbook-product-grid-modal.vue?vue&type=script&lang=js"
export * from "./lookbook-product-grid-modal.vue?vue&type=script&lang=js"

import "./lookbook-product-grid-modal.vue?vue&type=style&index=0&id=45498b54&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__